// The loader's fixed geometry (DESIGN-WL-BOOT-LOADER-MOTION-1). The
// pre-bundle overlay in index.html mirrors these literally (its :root
// custom properties); __tests__/bootLoaderRange.test.js pins the pair.
export default {
  // The range: a band across the bottom of the screen.
  loaderRange: '55vh',
  // The rising front's feather, and the front layer one feather taller than
  // the band (its top edge sits one feather above the band top).
  loaderFront: '44px',
  loaderFrontTop: '-44px',
  loaderFrontHeight: 'calc(100% + 44px)',
  // The art's summit (4.6 % down the band) — the mark rests just above it,
  // like a sun on the ridge, on every viewport.
  loaderSummit: 'calc(45vh + 55vh * 0.046)',
  // The mark's centre: 12px above the summit plus half the 56px mark.
  loaderCenter: 'calc(45vh + 55vh * 0.046 - 40px)',
  loaderMark: '56px',
  loaderLogoFont: 'calc(56px / 2.2)',
  // The stage line sits above the mark in the sky: centre - half the mark -
  // 20px - the 20px line.
  loaderStatusTop: 'calc(45vh + 55vh * 0.046 - 40px - 28px - 20px - 20px)',
  loaderStatusFont: '13px',
  // THE HOME'S GROUND (DESIGN-WL-HOME-SKY-TOP-GROUND-1): the band the
  // mountain range rises into at the end of the home scroll. The range art is
  // 3:1 (1440 x 480), so a third of the width shows it whole; never more than
  // 40 % of the viewport height, so the last widget row keeps its ground.
  groundBand: 'min(33.333vw, 40vh)',
  // THE SEARCH DROPDOWN'S HEIGHT (9A — Nika 2026-09-28: "make it a bit
  // taller"). The launcher body (components/SearchAppsMenu.js) caps at this
  // and scrolls INSIDE — its filter row and toolbar stay put while the tiles
  // or the results scroll. It was the house menu's 60vh; this is three
  // quarters of the viewport, never more than the panel's own viewport bound
  // leaves (the dropdown hangs under the header, so a full-height cap would
  // run off the bottom edge).
  searchPanelMaxH: 'min(76dvh, calc(100dvh - 96px))'
}
